import { gql } from 'apollo-boost';

export const REVOKE_API_TOKEN = gql`
    mutation RevokeApiToken($data: RevokeApiTokenInput!) {
        revokeApiToken(data: $data)
    }
`;
